/*

File handles all api calls for tenants


*/
import { browserHistory } from 'react-router'

import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Buildings = Class.create({
	// #  Eventually have class update data after update
	buildingID: 0,
	levelID: 0,
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
	},
	getBuildings: function(context) {
		var sortID = context.lastSortID;
		// #  Localize this instance for use on success
		var self = this;

		if(sortID === undefined || sortID == 0){
			return;
		}

		var url = "buildings/sort/" + sortID;
		// #  Send to server object for processing
		var data = this.server.getData(url,null, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			context.setState({
				data: response.data
			});
		})
		.fail(function(e){
			console.log(e);
		});
	},
	getBuilding: function(context) {
		var buildingID = context.state.buildingID;
		// #  Localize this instance for use on success
		var self = this;
	
		var url = "buildings/" + buildingID;
		// #  Send to server object for processing
		var data = self.server.getData(url,null, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}

			context.setState({
				data: response.data[0],
				building_level_total: response.data[0].belongsTo.building_level_total,
				hasIntegrations: response.data[0].meta_data.has_integrations,
				hasCameras: response.data[0].meta_data.has_cameras,
				hasAccessControl: response.data[0].meta_data.has_access_controls,
				selectedProperty: response.data[0].property
			});
		})
		.fail(function(e){
			console.log(e);
		});
	},
	getBuildingLevelData: function(context, callback = null) {
		var buildingID = context.state.buildingID;
		var levelID = context.state.levelID;
		// #  Localize this instance for use on success
		var self = this;

		var url = "buildings/" + buildingID + "/level/"  + levelID;
		// #  Send to server object for processing
		var data = self.server.getData(url,null, true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			context.setState({ levelData: response.data[0] });
			// #  Return callback if exist
			if(callback != null) {
				callback(response.data[0]);
			}
		})
		.fail(function(e){
			console.log(e);
		});
	},
	saveBuildingLevelFloorPlan: function(title, building_id, level_id) {
		var self = this;
		var url = "buildings/templates/level";
		var params = {
			'title' : title,
			'building_id': building_id,
			'level_id': level_id
		};
		// #  Send to server object for processing
		var data = this.server.getData(url,params, true, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
                modal.showInfo("Floor Plan "+title+" has been added!", "success", "top", "center");
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	loadBuildingLevelFloorPlan: function(building_id, callback) {
		var self = this;
		var url = "buildings/templates/level";
		var params = {
			'building_id': building_id,
		};
		// #  Send to server object for processing
		var data = this.server.getData(url,params, true, "GET");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	implementBuildingFloorPlan: function(template_floor_plan_id, building_id, level_id) {
		var self = this;
		var url = "buildings/templates/level/" + template_floor_plan_id;
		var params = {
			'building_id': building_id,
			'level_id': level_id
		};
		// #  Send to server object for processing
		var data = this.server.getData(url,params, true, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				modal.showInfo("Floor Plan has been applied.", "success", "top", "center");
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	updateBuildingData: function(buildingData, callback){
      var self = this;
      modal.showDangerModalWithOK("Are you sure?","You are about to update this building\'s information.","Yes, Update");
      // #  Bind okay button
      jQuery(".move-on").on('click',function() {
		// prepare our data to be sent
		var url = "buildings/update";
		var params = buildingData;
		// #  Send to server object for processing
		var data = self.server.getData(url,params, true, "PUT");
	    // #  Listen to our data
        data
        .done(function(response){
          // #  Validate response
          if(response.status == 1 || response.status == 2) {
            modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
          }
          else if(response.data.error != null)
          {
            modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
          }
          else
          {
            if(callback) {
				modal.showInfo("Building has been updated!", "success", "top", "center");
				callback(response);
			}
          }
        })
        .fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
        });
	  });
	},
	deleteBuilding: function(buildingID){
		var self = this;
		modal.showDangerModalWithOK("Are you sure?","You are about to delete this building and all related information.  This action cannot be recovered!","Yes, Delete");
		// #  Bind okay button
		jQuery(".move-on").on('click',function() {
		  // prepare our data to be sent
		  var url = "buildings/" + buildingID;
		  // #  Send to server object for processing
		  var data = self.server.getData(url,null, true, "DELETE");
		  // #  Listen to our data
		  data
		  .done(function(response){
			// #  Validate response
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
			  modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
			  // # .Hard reset backdrop
			  modal.resetBackDrop();
			  // #  Send out success message
			  modal.showSuccess("Building Deleted!","This building has been dropped.  All associated information with this building has been removed.");
			  // #  Bind okay button
			  jQuery(".move-on").on('click',function() {
				  browserHistory.replace('/buildings');
			  });
			}
		  })
		  .fail(function(e){
			console.log(e);
		  });
		});
	  },
	  getBuildingStatistics: function(buildingID, callback) {
		var self = this;
		var url = "buildings/stats/" + buildingID;
		// #  Send to server object for processing
		var data = this.server.getData(url,null, true, "GET");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	  },
	  saveBuildingTemplate: function(buildingID){
		var self = this;
		modal.showDangerModalWithOK("Are you sure?","You are about to create a building template.  This will save all associated data (besides tenants).","Yes, Duplicate");
		// #  Bind okay button
		jQuery(".move-on").on('click',function() {
		  // prepare our data to be sent
		  var url = "buildings/duplicate/" + buildingID;
		  // #  Send to server object for processing
		  var data = self.server.getData(url,null, true, "PUT");
		  // #  Listen to our data
		  data
		  .done(function(response){
			// #  Validate response
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
			  modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
			  // # .Hard reset backdrop
			  modal.resetBackDrop();
			  // #  Send out success message
			  modal.showSuccess("Building Duplicated!","This building has been duplicated.");
			  // #  Bind okay button
			  jQuery(".move-on").on('click',function() {
				  browserHistory.replace('/buildings');
			  });
			}
		  })
		  .fail(function(e){
			console.log(e);
		  });
		});
		},
		getLastEditedBuilding: function(callback) {
			var self = this;
			var url = "buildings/recentactivity";
			var data = this.server.getData(url,null, true, "GET");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1) {
				}
				else if(response.data.error || (response.status == 1 || response.status == 2)) {
				} else {
					if (callback) {
						callback(response);
					}
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
			});
		},
		getAllBuildingStats: function(callback) {
			var self = this;
			var url = "buildings/stats";
			var data = this.server.getData(url,null, true, "GET");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1) {
				}
				else if(response.data.error || (response.status == 1 || response.status == 2)) {
				} else {
					if (callback) {
						callback(response);
					}
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
			});
		},
		getBuildingSensorHistory: function(buildingID, callback) {
			var self = this;
			var url = "building/" + buildingID + "/stats";
			var data = self.server.getData(url,null, true);
			data
			.done(function(response){
				// #  Validate response
				if(response.data.error_user_authentication == 1)
				{
					modal.showInfo("Error occurred: " + response.data.error + ". Please try again!", "danger", "top", "center");
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
					modal.showInfo("Error occurred: " + response.data.error + ". Please try again!", "danger", "top", "center");
				} else {
					callback(response);
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
			});
		}
});

export let buildings = new Buildings();


// WEBPACK FOOTER //
// app/core/controllers/Buildings.js